import * as THREE from 'three';
import { DataManager } from '../data/DataManager';
import { ConnectingDotsRender } from './ConnectingDotsRender';
import { Params } from '../data/Params';
import { ScreenSize } from '../data/ScreenSize';
import points_vert from "../glsl/pointShader.vert";
import points_frag from "../glsl/pointShader.frag";

class MojisDotRender{

    numParticles:number=3500;
    material:THREE.ShaderMaterial
    //THREE.PointsMaterial;
    particles:THREE.Points;
    counter:number=0;
    countMax:number=0;

    positions:number[];
    scales:number[];
    geo:THREE.BufferGeometry;
    strokes:ConnectingDotsRender;

    private static Instance:MojisDotRender;

    public static getInstance(): MojisDotRender {
        
        if (!MojisDotRender.Instance) {
            MojisDotRender.Instance = new MojisDotRender();
            MojisDotRender.Instance.init();
        }

        return MojisDotRender.Instance;
    }

    init(){

        this.strokes = ConnectingDotsRender.getInstance();

        const positions = new Float32Array( this.numParticles * 3 );
        const scales = new Float32Array( this.numParticles );

        for ( let i = 0; i < this.numParticles; i++ ) {
            positions[ i*3 + 0 ] = 9999;//(Math.random()-0.5)*2000
            positions[ i*3 + 1 ] = 9999;//(Math.random()-0.5)*2000
            positions[ i*3 + 2 ] = 9999;//(Math.random()-0.5)*2000
            scales[ i ] = 1;
        }

        this.geo = new THREE.BufferGeometry();
        this.geo.setAttribute( 'position', new THREE.BufferAttribute( positions, 3 ) );
        this.geo.setAttribute( 'scale', new THREE.BufferAttribute( scales, 1 ) );

        //this.material = new THREE.PointsMaterial({color:0xffffff, size: 4});

        this.material = new THREE.ShaderMaterial( {
            uniforms: {
                color: { value: new THREE.Color( 0xffffff ) },
                size: { value: 4 }
            },
            vertexShader: points_vert,
            fragmentShader: points_frag
        } );


        this.particles = new THREE.Points( this.geo, this.material );
        //scene.add( particles );

        this.positions = this.particles.geometry.attributes.position.array as number[];
        this.scales = this.particles.geometry.attributes.scale.array as number[];


        DataManager.getInstance().gui?.add(this.particles,"visible");

        this.particles.position.z = Params.Z_DOTS;
        DataManager.getInstance().addScene(this.particles);
        DataManager.getInstance().gui?.add(this,"countMax").name("dotCount").listen();
        /*
        const positions = particles.geometry.attributes.position.array;
        const scales = particles.geometry.attributes.scale.array;

        //positions,scalesをアップデートして

        particles.geometry.attributes.position.needsUpdate = true;
        particles.geometry.attributes.scale.needsUpdate = true; 
        */

    }

    show(){
        this.particles.visible=true;
    }

    hide(){
        this.particles.visible=false;
    }

    resetCount(){
        this.counter=0;
        
    }

    setPoint(x:number,y:number,z:number,s:number){

        this.positions[this.counter*3+0] = x;
        this.positions[this.counter*3+1] = y;
        this.positions[this.counter*3+2] = z;

        this.scales[this.counter] = s;

        this.counter++;
        this.countMax=Math.max(this.counter,this.countMax);
        this.counter = this.counter%this.scales.length;

    }

    //pointsに従ってレンダリングします
    update(){

        //for(let i=0;i<this.scales.length;i++){
        //    this.scales[i]+=(1-this.scales[i])/10;
        //}

        this.geo.attributes.position.needsUpdate = true;
        this.geo.attributes.scale.needsUpdate = true;

        this.resetCount();

    }

    resize(){

        
        //this.material.size = ScreenSize.GetDotSize();
        this.material.uniforms.size.value = ScreenSize.GetDotSize();

    }


}

export {MojisDotRender};